/* tslint:disable */
/* eslint-disable */
/**
 * Distributor API
 * The Cashlink Distributor API enables you to distribute crypto securities and digital securities. It contains all building blocks from investor registration and KYC/AML to brokerage, clearing and settlement processes. While you are in full control of the frontends served to your investors you can use the Cashlink Studio to monitor and manage the activity on your platform.   Note: You cannot access data of investors or investments if they haven\'t been created via the API with your provided API credentials. Also, it\'s not possible to access data of investors that have registered via the Cashlink Signing Module, if you are using this as well.  ### Authentication  Every call to the API must be authenticated via OAuth client credentials. During setup, your point of contact will provide you with your client ID and client secret.   ### Idempotency  For certain POST endpoints, the API uses client-supplied idempotency keys to ensure that requests can be retried safely without performing the same operation twice. Repeated calls to those endpoints with the same idempotency key will return the cached response from the first call. Keys are expected to be set as header parameters with *X-Idempotency-Key*. The recommended approach for interacting with such endpoints is as follows:   - Create a unique, random key, such as a UUIDv4.   - Store the intent to call an endpoint along with the generated key in the client database.   - Flush to disk (e.g. commit an SQL transaction).   - Perform the call to the endpoint.   This ensures that even if the response from the API to a client gets lost, or the client experiences any sort of outage between steps 3 and 4, the client can always safely retry the same action.   If you already have objects corresponding to tasks in the API in your client-side database, you can use their internal IDs as idempotency keys!   ### Monetary values   Monetary values are represented as a combination of amount, decimals & currency. For example, ```{\'amount\': \'40000000\', \'decimals\': 3, \'currency\': \'EUR\'} means \'EUR 40,000.000\'```.   ### Handling documents  The document endpoint can be used to upload documents. Files are uploaded via HTTP multipart. The endpoint will return a document ID that can be used in other requests to refer to that document.   ### Webhooks  You can also register webhooks so that we can notify your application about events with regards to investments. To use that, please provide your point of contact at Cashlink with the following data:   - URL to be used as the target for webhooks  - OAuth client credentials or bearer authentication token so that we can authenticate at your server.  Webhooks are sent every time the status of an investment changes.  **POST <customer-provided URL>**  Webhooks are retried until the called endpoint returns a 2xx.  **Request**  {  \'investment_id\': \'3fa85f64-5717-4562-b3fc-2c963f66afa6\',  \'status\': \'ACCEPTED\',  \'changed_at\': \'2020-12-11T14:59:46.716Z\'  }  ### Concepts  The Cashlink Distributor API is based on the following concepts:  - Persons (legal or natural) that are users on your platform willing to invest are called investors.  - These investors will be able to invest into different financial products issued by different entities. In the API they are called products.  - The purchase of units of such a product takes place within your application and ends with a signed investment contract.  - Now you can create an investment, which contains the investor, the units, the signed investment contract and the accepted date of the investment by the issuer.   - At some point, parts of the investments are returned to the issuer because the outstanding amount has been paid back for example. Such a transaction is called a redemption.    
 *
 * The version of the OpenAPI document: v2
 * Contact: support@cashlink.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AnonymousProduct,
  PaginatedAnonymousProductList,
  PaginatedDropdownElementList,
} from '../models/index';
import {
    AnonymousProductFromJSON,
    AnonymousProductToJSON,
    PaginatedAnonymousProductListFromJSON,
    PaginatedAnonymousProductListToJSON,
    PaginatedDropdownElementListFromJSON,
    PaginatedDropdownElementListToJSON,
} from '../models/index';

export interface ProductsForPublicationDropdownListRequest {
    assetCode?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    field?: ProductsForPublicationDropdownListFieldEnum;
    id?: string;
    isin?: string;
    issuerCompanyName?: string;
    latestPublicationVersion?: string;
    limit?: number;
    name?: string;
    network?: ProductsForPublicationDropdownListNetworkEnum;
    offset?: number;
    ordering?: ProductsForPublicationDropdownListOrderingEnum;
    publicationDateAfter?: Date;
    publicationDateBefore?: Date;
    search?: string;
    smartContractAddress?: string;
}

export interface ProductsForPublicationListRequest {
    assetCode?: Array<string>;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    id?: Array<string>;
    isin?: Array<string>;
    issuerCompanyName?: Array<string>;
    latestPublicationVersion?: Array<string>;
    limit?: number;
    name?: Array<string>;
    network?: Array<ProductsForPublicationListNetworkEnum>;
    offset?: number;
    ordering?: ProductsForPublicationListOrderingEnum;
    publicationDateAfter?: Date;
    publicationDateBefore?: Date;
    search?: string;
    smartContractAddress?: Array<string>;
}

export interface ProductsForPublicationRetrieveRequest {
    id: string;
}

export interface ProductsForPublicationValuesRetrieveRequest {
    field: ProductsForPublicationValuesRetrieveFieldEnum;
    assetCode?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    icontains?: string;
    id?: string;
    isin?: string;
    issuerCompanyName?: string;
    latestPublicationVersion?: string;
    name?: string;
    network?: ProductsForPublicationValuesRetrieveNetworkEnum;
    ordering?: ProductsForPublicationValuesRetrieveOrderingEnum;
    publicationDateAfter?: Date;
    publicationDateBefore?: Date;
    search?: string;
    smartContractAddress?: string;
}

/**
 * 
 */
export class ProductsForPublicationApi extends runtime.BaseAPI {

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async productsForPublicationDropdownListRaw(requestParameters: ProductsForPublicationDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['assetCode'] != null) {
            queryParameters['asset_code'] = requestParameters['assetCode'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['isin'] != null) {
            queryParameters['isin'] = requestParameters['isin'];
        }

        if (requestParameters['issuerCompanyName'] != null) {
            queryParameters['issuer_company_name'] = requestParameters['issuerCompanyName'];
        }

        if (requestParameters['latestPublicationVersion'] != null) {
            queryParameters['latest_publication_version'] = requestParameters['latestPublicationVersion'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['network'] != null) {
            queryParameters['network'] = requestParameters['network'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['publicationDateAfter'] != null) {
            queryParameters['publication_date_after'] = (requestParameters['publicationDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['publicationDateBefore'] != null) {
            queryParameters['publication_date_before'] = (requestParameters['publicationDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['smartContractAddress'] != null) {
            queryParameters['smart_contract_address'] = requestParameters['smartContractAddress'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/products-for-publication/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async productsForPublicationDropdownList(requestParameters: ProductsForPublicationDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.productsForPublicationDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all products.
     */
    async productsForPublicationListRaw(requestParameters: ProductsForPublicationListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAnonymousProductList>> {
        const queryParameters: any = {};

        if (requestParameters['assetCode'] != null) {
            queryParameters['asset_code'] = requestParameters['assetCode'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['isin'] != null) {
            queryParameters['isin'] = requestParameters['isin'];
        }

        if (requestParameters['issuerCompanyName'] != null) {
            queryParameters['issuer_company_name'] = requestParameters['issuerCompanyName'];
        }

        if (requestParameters['latestPublicationVersion'] != null) {
            queryParameters['latest_publication_version'] = requestParameters['latestPublicationVersion'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['network'] != null) {
            queryParameters['network'] = requestParameters['network'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['publicationDateAfter'] != null) {
            queryParameters['publication_date_after'] = (requestParameters['publicationDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['publicationDateBefore'] != null) {
            queryParameters['publication_date_before'] = (requestParameters['publicationDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['smartContractAddress'] != null) {
            queryParameters['smart_contract_address'] = requestParameters['smartContractAddress'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/products-for-publication/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAnonymousProductListFromJSON(jsonValue));
    }

    /**
     * List all products.
     */
    async productsForPublicationList(requestParameters: ProductsForPublicationListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAnonymousProductList> {
        const response = await this.productsForPublicationListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async productsForPublicationRetrieveRaw(requestParameters: ProductsForPublicationRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnonymousProduct>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling productsForPublicationRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/products-for-publication/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnonymousProductFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async productsForPublicationRetrieve(requestParameters: ProductsForPublicationRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnonymousProduct> {
        const response = await this.productsForPublicationRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async productsForPublicationValuesRetrieveRaw(requestParameters: ProductsForPublicationValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling productsForPublicationValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assetCode'] != null) {
            queryParameters['asset_code'] = requestParameters['assetCode'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['isin'] != null) {
            queryParameters['isin'] = requestParameters['isin'];
        }

        if (requestParameters['issuerCompanyName'] != null) {
            queryParameters['issuer_company_name'] = requestParameters['issuerCompanyName'];
        }

        if (requestParameters['latestPublicationVersion'] != null) {
            queryParameters['latest_publication_version'] = requestParameters['latestPublicationVersion'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['network'] != null) {
            queryParameters['network'] = requestParameters['network'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['publicationDateAfter'] != null) {
            queryParameters['publication_date_after'] = (requestParameters['publicationDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['publicationDateBefore'] != null) {
            queryParameters['publication_date_before'] = (requestParameters['publicationDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['smartContractAddress'] != null) {
            queryParameters['smart_contract_address'] = requestParameters['smartContractAddress'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/products-for-publication/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async productsForPublicationValuesRetrieve(requestParameters: ProductsForPublicationValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.productsForPublicationValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ProductsForPublicationDropdownListFieldEnum = {
    ASSET_CODE: 'asset_code',
    ISIN: 'isin',
    ISSUER_COMPANY_NAME: 'issuer_company_name',
    LATEST_PUBLICATION_VERSION: 'latest_publication_version',
    NAME: 'name',
    NETWORK: 'network',
    SMART_CONTRACT_ADDRESS: 'smart_contract_address'
} as const;
export type ProductsForPublicationDropdownListFieldEnum = typeof ProductsForPublicationDropdownListFieldEnum[keyof typeof ProductsForPublicationDropdownListFieldEnum];
/**
 * @export
 */
export const ProductsForPublicationDropdownListNetworkEnum = {
    ETH_DEV: 'eth-dev',
    ETH_MAINNET: 'eth-mainnet',
    ETH_SEPOLIA: 'eth-sepolia',
    ETH_TEST: 'eth-test',
    POLYGON_AMOY: 'polygon-amoy',
    POLYGON_MAINNET: 'polygon-mainnet',
    STELLAR_DEV: 'stellar-dev',
    STELLAR_PUBNET: 'stellar-pubnet',
    STELLAR_TEST: 'stellar-test',
    STELLAR_TESTNET: 'stellar-testnet'
} as const;
export type ProductsForPublicationDropdownListNetworkEnum = typeof ProductsForPublicationDropdownListNetworkEnum[keyof typeof ProductsForPublicationDropdownListNetworkEnum];
/**
 * @export
 */
export const ProductsForPublicationDropdownListOrderingEnum = {
    ASSET_CODE_DESC: '-asset_code',
    ASSET_CODE_ASC: 'asset_code',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    ISIN_DESC: '-isin',
    ISIN_ASC: 'isin',
    ISSUER_COMPANY_NAME_DESC: '-issuer_company_name',
    ISSUER_COMPANY_NAME_ASC: 'issuer_company_name',
    LATEST_PUBLICATION_VERSION_DESC: '-latest_publication_version',
    LATEST_PUBLICATION_VERSION_ASC: 'latest_publication_version',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    NETWORK_DESC: '-network',
    NETWORK_ASC: 'network',
    PUBLICATION_DATE_DESC: '-publication_date',
    PUBLICATION_DATE_ASC: 'publication_date',
    SMART_CONTRACT_ADDRESS_DESC: '-smart_contract_address',
    SMART_CONTRACT_ADDRESS_ASC: 'smart_contract_address'
} as const;
export type ProductsForPublicationDropdownListOrderingEnum = typeof ProductsForPublicationDropdownListOrderingEnum[keyof typeof ProductsForPublicationDropdownListOrderingEnum];
/**
 * @export
 */
export const ProductsForPublicationListNetworkEnum = {
    ETH_DEV: 'eth-dev',
    ETH_MAINNET: 'eth-mainnet',
    ETH_SEPOLIA: 'eth-sepolia',
    ETH_TEST: 'eth-test',
    POLYGON_AMOY: 'polygon-amoy',
    POLYGON_MAINNET: 'polygon-mainnet',
    STELLAR_DEV: 'stellar-dev',
    STELLAR_PUBNET: 'stellar-pubnet',
    STELLAR_TEST: 'stellar-test',
    STELLAR_TESTNET: 'stellar-testnet'
} as const;
export type ProductsForPublicationListNetworkEnum = typeof ProductsForPublicationListNetworkEnum[keyof typeof ProductsForPublicationListNetworkEnum];
/**
 * @export
 */
export const ProductsForPublicationListOrderingEnum = {
    ASSET_CODE_DESC: '-asset_code',
    ASSET_CODE_ASC: 'asset_code',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    ISIN_DESC: '-isin',
    ISIN_ASC: 'isin',
    ISSUER_COMPANY_NAME_DESC: '-issuer_company_name',
    ISSUER_COMPANY_NAME_ASC: 'issuer_company_name',
    LATEST_PUBLICATION_VERSION_DESC: '-latest_publication_version',
    LATEST_PUBLICATION_VERSION_ASC: 'latest_publication_version',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    NETWORK_DESC: '-network',
    NETWORK_ASC: 'network',
    PUBLICATION_DATE_DESC: '-publication_date',
    PUBLICATION_DATE_ASC: 'publication_date',
    SMART_CONTRACT_ADDRESS_DESC: '-smart_contract_address',
    SMART_CONTRACT_ADDRESS_ASC: 'smart_contract_address'
} as const;
export type ProductsForPublicationListOrderingEnum = typeof ProductsForPublicationListOrderingEnum[keyof typeof ProductsForPublicationListOrderingEnum];
/**
 * @export
 */
export const ProductsForPublicationValuesRetrieveFieldEnum = {
    ASSET_CODE: 'asset_code',
    ISIN: 'isin',
    ISSUER_COMPANY_NAME: 'issuer_company_name',
    LATEST_PUBLICATION_VERSION: 'latest_publication_version',
    NAME: 'name',
    NETWORK: 'network',
    SMART_CONTRACT_ADDRESS: 'smart_contract_address'
} as const;
export type ProductsForPublicationValuesRetrieveFieldEnum = typeof ProductsForPublicationValuesRetrieveFieldEnum[keyof typeof ProductsForPublicationValuesRetrieveFieldEnum];
/**
 * @export
 */
export const ProductsForPublicationValuesRetrieveNetworkEnum = {
    ETH_DEV: 'eth-dev',
    ETH_MAINNET: 'eth-mainnet',
    ETH_SEPOLIA: 'eth-sepolia',
    ETH_TEST: 'eth-test',
    POLYGON_AMOY: 'polygon-amoy',
    POLYGON_MAINNET: 'polygon-mainnet',
    STELLAR_DEV: 'stellar-dev',
    STELLAR_PUBNET: 'stellar-pubnet',
    STELLAR_TEST: 'stellar-test',
    STELLAR_TESTNET: 'stellar-testnet'
} as const;
export type ProductsForPublicationValuesRetrieveNetworkEnum = typeof ProductsForPublicationValuesRetrieveNetworkEnum[keyof typeof ProductsForPublicationValuesRetrieveNetworkEnum];
/**
 * @export
 */
export const ProductsForPublicationValuesRetrieveOrderingEnum = {
    ASSET_CODE_DESC: '-asset_code',
    ASSET_CODE_ASC: 'asset_code',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    ISIN_DESC: '-isin',
    ISIN_ASC: 'isin',
    ISSUER_COMPANY_NAME_DESC: '-issuer_company_name',
    ISSUER_COMPANY_NAME_ASC: 'issuer_company_name',
    LATEST_PUBLICATION_VERSION_DESC: '-latest_publication_version',
    LATEST_PUBLICATION_VERSION_ASC: 'latest_publication_version',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    NETWORK_DESC: '-network',
    NETWORK_ASC: 'network',
    PUBLICATION_DATE_DESC: '-publication_date',
    PUBLICATION_DATE_ASC: 'publication_date',
    SMART_CONTRACT_ADDRESS_DESC: '-smart_contract_address',
    SMART_CONTRACT_ADDRESS_ASC: 'smart_contract_address'
} as const;
export type ProductsForPublicationValuesRetrieveOrderingEnum = typeof ProductsForPublicationValuesRetrieveOrderingEnum[keyof typeof ProductsForPublicationValuesRetrieveOrderingEnum];
